export default ({ navbarBackground }) => ({
  '.navbar': {
    backgroundColor: navbarBackground,
  },
});
